import type { PropsWithChildren } from 'react';
import React from 'react';
import { xcss } from '@atlaskit/primitives';

const styles = {
  paypalButtonStyles: xcss({
    minHeight: '30px',
  }),
};

export const PaypalButtonContainer: React.FC<PropsWithChildren<unknown>> = ({ children }) => {
  return <div css={styles.paypalButtonStyles}>{children}</div>;
};
